import React from 'react';
import useCreateImportInfo
    from "v4/pages/admin/Import/components/ImportSteps/components/CreateImport/components/CreateImportInfo/hooks/useCreateImportInfo";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";

export default function CreateImportInfo() {
    const {t} = usePolTranslation();
    const {selectedEntityType, isInfoLoading, availableFields} = useCreateImportInfo();

    if (isInfoLoading) return <InlineLoader/>;

    return (
        <div className="create-import__info">
            <p className="create-import__info__title">
            {selectedEntityType
                ? t('import_fields_available_for_entity', {entity: t(selectedEntityType)})
                : t('select_entity_to_see_fields')
            }
            </p>
            {availableFields.length > 0 && (
                <ul className="create-import__info__fields">
                    {availableFields.map(({label, key}) => (
                        <li key={key}>{t(label)}</li>
                    ))}
                </ul>
            )}
        </div>
    )
}
